import {
  Route,
  Switch,
  Redirect,
  useLocation,
  useRouteMatch
} from "react-router-dom";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { trackAnalyticsEvent } from "state/actions/AnalyticsActions";

import ContentSearch from "components/content/ContentSearch";
import ContentFollowed from "components/content/ContentFollowed";
import ContentTopicDetail from "components/content/ContentTopicDetail";
import ContentPreferences from "components/content/ContentPreferences";
import ContentInfluencers from "components/content/ContentInfluencers";
import ContentSavedForLater from "components/content/ContentSavedForLater";
import ContentInfluencerDetail from "components/content/ContentInfluencerDetail";
import ContentForYou from "components/content/ContentForYou";
import UserIdeas from "components/ideas/UserIdeas/UserIdeas";
import PostingIdeasPage from "./PostingdeasPage";

const ContentRouter: React.FC<{}> = React.memo(() => {
  const match = useRouteMatch();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const pageType =
      location.pathname.match(
        /^.*\/accounts\/[^/]*\/ideas\/([^/?]*).*$/
      )?.[1] ?? "";

    if (!!pageType) {
      dispatch(
        trackAnalyticsEvent("News Viewed", {
          pageType
        })
      );
    }
  }, [dispatch, location.pathname]);

  return (
    <Switch>
      <Route path={match.url + "/your-ideas"} component={UserIdeas} />
      <Route path={match.url + "/inspiration"} component={PostingIdeasPage} />
      <Route
        path={match.url + "/whatsapp"}
        render={params => <UserIdeas origin="whatsapp" {...params} />}
      />
      <Route
        path={match.url + "/saved-for-later"}
        component={ContentSavedForLater}
      />
      <Route path={match.url + "/for-you"} component={ContentForYou} />
      <Route path={match.url + "/preferences"} component={ContentPreferences} />
      <Route path={match.url + "/search"} component={ContentSearch} />
      <Route
        path={match.url + "/topics/:topicId/:language"}
        component={ContentTopicDetail}
      />
      <Route path={match.url + "/topics"} component={ContentFollowed} />
      <Route
        path={match.url + "/domains/:sourceId"}
        render={params => (
          <ContentInfluencerDetail sourceType="domains" {...params} />
        )}
      />

      <Route
        path={match.url + "/influencers/:sourceId"}
        render={params => (
          <ContentInfluencerDetail sourceType="twitter" {...params} />
        )}
      />
      <Route
        path={match.url + "/influencers"}
        render={() => <ContentInfluencers sourceType="twitter" />}
      />

      {/* Optional: Add a redirect or a default route */}
      <Redirect exact from={match.url} to={match.url + "/your-ideas"} />
    </Switch>
  );
});

export default ContentRouter;
